import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularFireStorage } from '@angular/fire/storage';
import { CONFIGURAZIONE, Configurazione } from './app';

@Component({
  selector: 'app-photo-dialog',
  templateUrl: './photo-dialog.component.html'
})
export class PhotoDialogComponent {
  src: any;
  _mp: any;
  ingredienti: any;

  constructor(
    private storage : AngularFireStorage,
    @Inject(CONFIGURAZIONE) public configuration: Configurazione,
    public dialogRef: MatDialogRef<PhotoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mp: any) {
      this.src = `https://storage.googleapis.com/${(<any>this.storage.storage.app.options).storageBucket}/${configuration.liid}/${mp.Foto}`;
      this._mp = mp;
      this.ingredienti = this.Ingredienti(this._mp)
     }

     Ingredienti(_mp) {
      const mis = this.configuration.menu_piatto_ingrediente.filter(_it => _it.Piatto == _mp.Guid).map(_it => {
        return this.configuration.menu_ingrediente.find(__it => __it.Guid == _it.Ingrediente).Nome;
      });
      return mis;
    }
  
  public Close(result : boolean) {
    this.dialogRef.close(result);
  }
}